export const Validators = {
  SPECIAL_CHARACTER: /[!@#$%^&*(),.?":{}|<>]/,
  REGISTRATION_NUMBER: /^[a-zA-Z0-9]{4,10}$/,
  CAPITAL_CASE: /[A-Z]/,
  LOWER_CASE: /[a-z]/,
  DIGIT: /\d/,
  ZIP_CODE: /\d\d-\d\d\d/,
  NIP: (value: string | number): boolean => {
    const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
    const nip = String(value).replace(/-/g, '');
    const sum = weights.reduce(
      (acc, weight, index) => acc + weight * parseInt(nip[index] ?? '1', 10),
      0,
    );
    return !!nip[9] && sum % 11 === parseInt(nip[9], 10);
  },
};
